// core
import React from "react";
import Icon from "../../../../../common/components/Icon/Icon";

// interfaces
interface IQuoteTablePolicyFeatureCellProps {
    detail: string;
    detailMore?: string;
}

// functions

// rendering
const QuoteTablePolicyFeatureCell: React.FC<IQuoteTablePolicyFeatureCellProps> = (
    props
) => {
    let detailMore = props.detailMore;
    let detailMoreSubtext = undefined;

    if (
        props.detail !== "[Tick]" &&
        props.detail !== "[Cross]" &&
        props.detail !== "Partial"
    ) {
        detailMoreSubtext = props.detailMore;
        detailMore = props.detail;
    }

    return (
        <div className="layout-flex-column--centered layout-small-cell layout-policy-feature">
            {props.detail === "[Tick]" && <Icon id="SaveTick" />}
            {props.detail === "[Cross]" && <Icon id="RedCross" />}
            {props.detail === "Partial" && !detailMore && <Icon id="SliderMinus" />}
            {detailMore && <span>{detailMore}</span>}
            {detailMoreSubtext && <span>{detailMoreSubtext}</span>}
        </div>
    );
};

export default React.memo(QuoteTablePolicyFeatureCell);
